import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axios/axios';

const accessToken = localStorage.getItem('agentModuleToken');

export const fetchBonus = createAsyncThunk(
    'bonus/fetchBonus',
    async (term) => {
        const resp = await axios.post('/loan/bonus/list', {
            keyword: term,
            sortKey: "created_at",
            sortOrder: "desc",
        }, {
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        return resp?.data?.data;
    }
)

const initialState = {
    bonus: [],
    loading: false
}

const bonusSlice = createSlice({
    name: 'bonus',
    initialState,
    reducers: {
    },
    extraReducers: {
        [fetchBonus.pending]: (state) => {
            state.loading = true;
        },
        [fetchBonus.fulfilled]: (state, { payload }) => {
            return { ...state, loading: false, bonus: payload };
        }
    }
});


export const getBonus = (state) => state.bonus;

export default bonusSlice.reducer;